//
// Index file

module.exports = require("./JSFileManager");
module.exports.JSFile = require("./JSFile");
